/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum ValueRangeTypes {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DAYS",
  SECONDS = "SECONDS",
  AMOUNT = "AMOUNT",
}
